import Provider from "helpers/hooks/useGlobalContext";
import "index.css";
import Cart from "pages/Cart";
import Congratulation from "pages/Congratulations";
import Details from "pages/Details";
import HomePage from "pages/HomePage";
import NotFound from "pages/NotFound";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <Provider>
      <Routes>
        <Route path="/" Component={HomePage} />
        <Route path="/categories/:idc/products/:idp" Component={Details} />
        <Route path="/cart" Component={Cart} />
        <Route path="/congratulation" Component={Congratulation} />
        <Route path="*" Component={NotFound} />
      </Routes>
    </Provider>
  );
}

export default App;
